<template>
  <div>
    <div class="row gutter-sm" v-for="(phone, index) in phones" :key="index">
      <div :class="[phonesNotEmpty ? 'col-11' : 'col-12']">
        <phone-input
          @input="updatePhone($event, index)"
          :value="phones[index]"
          :id="index"
          :label="label"
          :hideLabel="hideLabel"
          :showIcon="showIcon"
        />
      </div>

      <div v-show="phonesNotEmpty" class="col-1 text-right">
        <q-btn flat dense icon="remove_circle" color="light" class="q-mt-lg" @click="clearPhone(index)"/>
      </div>
    </div>
    <div class="row justify-end">
      <q-btn flat dense
             v-show="phonesNotEmpty"
             @click="addPhone"
             :label="$t('additional_phone')"
             :class="showControls ? 'q-mr-xl' : ''"
      />
    </div>
  </div>
</template>

<script>
  import CustomerPhoneNumber from 'src/utils/SubResources/CustomerPhoneNumber'
  import PhoneInput from './PhoneInput.vue'
  import { isEqual } from 'lodash'

  export default {
    inject: ['$validator'],

    props: {
      /**
       * Used for v-model
       */
      value: {
        type: Array,
        required: true
      },

      /**
       * Indicate if the label input should be visible
       */
      label: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the label of the phone line field should be visible
       */
      hideLabel: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the field icon should be visibile
       */
      showIcon: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        phones: this.value
      }
    },

    computed: {
      showControls () {
        return this.phones.length > 1
      },

      phonesNotEmpty () {
        return !this.isEmptyPhone(this.phones[0])
      }
    },

    methods: {
      updatePhone (value, index) {
        this.phones.splice(index, 1, value)

        this.createDefaultPhone()

        this.emitPhones()
      },

      addPhone () {
        this.phones.push(CustomerPhoneNumber.empty())
      },

      createDefaultPhone () {
        if (this.phones.length === 0) {
          this.addPhone()
        }
      },

      clearPhone (index) {
        this.phones.splice(index, 1)
      },

      isEmptyPhone (email) {
        return isEqual(email, CustomerPhoneNumber.empty())
      },

      emitPhones () {
        this.$emit('input', this.phones)
      }
    },

    created () {
      this.createDefaultPhone()
    },

    watch: {
      value: {
        handler: function (newPhones) {
          this.phones = newPhones

          this.createDefaultPhone()
        },
        deep: true
      }
    },

    components: {
      PhoneInput
    }
  }
</script>
